import React, { useMemo } from "react";
import {
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import AIReviewedChip from "./AIReviewedChip";
import DataSourceIcon from "../../Components/DataSourcesPanel";

const InvestmentCommentarySection = ({
  investmentCommentary,
  entityId,
  AiSectionFeedback,

  // NEW (for backend feedback integration)
  requestId,
  uiSectionKey = "investment_commentary",
  userEmail,
}) => {
  const items = investmentCommentary || [];

  // ✅ Left column always gets the extra item when count is odd
  const { leftItems, rightItems } = useMemo(() => {
    const mid = Math.ceil(items.length / 2);
    return {
      leftItems: items.slice(0, mid),
      rightItems: items.slice(mid),
    };
  }, [items]);

  return (
    <Card
      sx={{
        mt: 4,
        borderRadius: "0.75rem",
        border: "none",
        boxShadow: "0 10px 25px rgba(15,23,42,0.1)",
        bgcolor: "#ffffff",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
            gap: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Tooltip
              title="AI commentary linking mandate performance, ratings and external context."
              arrow
            >
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  fontSize: "0.95rem",
                  color: "#003366",
                  cursor: "help",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                Investment Commentary
              </Typography>
            </Tooltip>
            <AIReviewedChip mode="light" />
            <DataSourceIcon mode="light" sources={["Nasdaq", "Web Search"]} />
          </Box>

          <AiSectionFeedback
            sectionName="EntityProfile - Investment Commentary (AI)"
            entityId={entityId}
            variant="light"
            requestId={requestId}
            uiSectionKey={uiSectionKey}
            userEmail={userEmail}
          />
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: 2,
            alignItems: "start",
          }}
        >
          <List dense sx={{ pt: 0, m: 0 }}>
            {leftItems.map((text, idx) => (
              <ListItem
                key={`left-${idx}`}
                sx={{ py: 0.4, alignItems: "flex-start" }}
              >
                <ListItemIcon sx={{ minWidth: 26, my: "auto" }}>
                  <ArrowRightAltIcon sx={{ fontSize: 16, color: "#003366" }} />
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  primaryTypographyProps={{
                    fontSize: "0.8rem",
                    lineHeight: 1.35,
                  }}
                />
              </ListItem>
            ))}
          </List>

          <List dense sx={{ pt: 0, m: 0 }}>
            {rightItems.map((text, idx) => (
              <ListItem
                key={`right-${idx}`}
                sx={{ py: 0.4, alignItems: "flex-start" }}
              >
                <ListItemIcon sx={{ minWidth: 26, my: "auto" }}>
                  <ArrowRightAltIcon sx={{ fontSize: 16, color: "#003366" }} />
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  primaryTypographyProps={{
                    fontSize: "0.8rem",
                    lineHeight: 1.35,
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </CardContent>
    </Card>
  );
};

export default InvestmentCommentarySection;
